import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-field" }
const _hoisted_2 = {
  class: "p-field-label",
  for: "badgecode"
}
const _hoisted_3 = { class: "p-field-with-button" }
const _hoisted_4 = { class: "bt-icon bt-icon--xs" }
const _hoisted_5 = { class: "ml-2" }
const _hoisted_6 = {
  for: "badgecode",
  class: "fs-13 label-error"
}
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = { class: "p-field-label mb-3" }
const _hoisted_9 = {
  key: 1,
  class: "no-badge text-center my-4"
}
const _hoisted_10 = { class: "text-gray" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_BadgeItem = _resolveComponent("BadgeItem")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addBadge && _ctx.addBadge(...args)), ["prevent"]))
      }, [
        _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("AppResourceEP.Code")), 1),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_InputText, {
            id: "badgecode",
            type: "text",
            class: ["w-100", {
                        'input-error': !_ctx.isValidCode,
                    }],
            placeholder: _ctx.$t('AppResourceEP.BadgeAddManuallySubtitle'),
            autocomplete: "off",
            modelValue: _ctx.badgeCode,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.badgeCode = $event))
          }, null, 8, ["placeholder", "modelValue", "class"]),
          _createVNode(_component_Button, {
            class: "p-button-outlined p-button-rounded p-button-field",
            disabled: _ctx.addButtonDisabled,
            type: "submit"
          }, {
            default: _withCtx(() => [
              _createVNode("span", _hoisted_4, [
                _createVNode(_component_InlineSvgScoped, {
                  src: 
                                require(`@/assets/images/icons/icon-plus-outline.svg`)
                            ,
                  "aria-label": "icon-plus-outline"
                }, null, 8, ["src"])
              ]),
              _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("AppResource.Add")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 32),
      _createVNode("label", _hoisted_6, _toDisplayString(_ctx.invalidCodeReason), 1)
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("entrancePlant.BadgeAddedList")), 1),
      _createVNode(_component_ElScrollbar, {
        class: ["added-badge-list", { 'scrollable-badges': !_ctx.gateGuest }]
      }, {
        default: _withCtx(() => [
          (_ctx.badgesList.length > 0)
            ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.badgesList, (addedBadge, index) => {
                return (_openBlock(), _createBlock(_component_BadgeItem, {
                  class: "mx-3 my-2",
                  small: "",
                  key: index,
                  badge: addedBadge,
                  onDeleteBadge: _ctx.removeBadge
                }, null, 8, ["badge", "onDeleteBadge"]))
              }), 128))
            : (_openBlock(), _createBlock("div", _hoisted_9, [
                _createVNode("small", _hoisted_10, _toDisplayString(_ctx.noBadgeText[0]), 1)
              ]))
        ]),
        _: 1
      }, 8, ["class"])
    ])
  ], 64))
}